import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-hidden" }
const _hoisted_2 = { class: "card border-0 shadow-none rounded-1 mb-25" }
const _hoisted_3 = { class: "card-body p-xl-40" }
const _hoisted_4 = { class: "row g-3 align-items-center" }
const _hoisted_5 = { class: "col-lg-8" }
const _hoisted_6 = { class: "d-flex flex-wrap align-items-center gap-2" }
const _hoisted_7 = {
  type: "button",
  class: "btn style-two px-4 h-55",
  "data-bs-toggle": "modal",
  "data-bs-target": "#purchasePaymentFilterModal"
}
const _hoisted_8 = { class: "search-box position-relative" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "col-lg-4" }
const _hoisted_11 = { class: "d-flex justify-content-lg-end" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  class: "modal fade",
  id: "purchasePaymentFilterModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_14 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_15 = { class: "modal-content border-0 shadow" }
const _hoisted_16 = { class: "modal-header border-bottom-dashed" }
const _hoisted_17 = { class: "modal-title fw-bold" }
const _hoisted_18 = ["aria-label"]
const _hoisted_19 = { class: "modal-body" }
const _hoisted_20 = { class: "row g-3" }
const _hoisted_21 = { class: "col-12" }
const _hoisted_22 = { class: "form-label fs-14 text-title" }
const _hoisted_23 = { value: null }
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "col-12" }
const _hoisted_26 = { class: "form-label fs-14 text-title" }
const _hoisted_27 = { value: null }
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "col-12" }
const _hoisted_30 = { class: "form-label fs-14 text-title" }
const _hoisted_31 = { value: null }
const _hoisted_32 = ["value"]
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = { class: "form-label fs-14 text-title" }
const _hoisted_35 = { class: "col-md-6" }
const _hoisted_36 = { class: "form-label fs-14 text-title" }
const _hoisted_37 = { class: "modal-footer border-top-dashed justify-content-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainSidebar = _resolveComponent("MainSidebar")!
  const _component_BreadcrumbMenu = _resolveComponent("BreadcrumbMenu")!
  const _component_PurchasePaymentReportContent = _resolveComponent("PurchasePaymentReportContent")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainHeader),
    _createVNode(_component_MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BreadcrumbMenu, { pageTitle: "purchase_payment_report_page.title" }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", _hoisted_7, [
                  _createTextVNode(_toDisplayString(_ctx.$t("purchase_payment_report_page.filter")) + " ", 1),
                  _cache[9] || (_cache[9] = _createElementVNode("i", { class: "ri-filter-line ms-1" }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
                    type: "text",
                    placeholder: _ctx.$t('purchase_payment_report_page.search_placeholder'),
                    class: "form-control bg-white h-55 shadow-none pe-5"
                  }, null, 8, _hoisted_9), [
                    [_vModelText, _ctx.searchQuery]
                  ]),
                  _cache[10] || (_cache[10] = _createElementVNode("span", { class: "search-icon" }, [
                    _createElementVNode("i", { class: "ri-search-line" })
                  ], -1))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn style-three d-inline-flex align-items-center h-55 px-4",
                  disabled: _ctx.exporting,
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.exportPurchasePaymentReports && _ctx.exportPurchasePaymentReports(...args)))
                }, [
                  _cache[11] || (_cache[11] = _createElementVNode("i", { class: "ri-file-excel-2-line me-1" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.exporting ? _ctx.$t("purchase_payment_report_page.exporting") : _ctx.$t("purchase_payment_report_page.excel")), 1)
                ], 8, _hoisted_12)
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_PurchasePaymentReportContent, {
        payments: _ctx.payments,
        loading: _ctx.loading,
        pagination: _ctx.pagination,
        onTableChange: _ctx.handleTableChange
      }, null, 8, ["payments", "loading", "pagination", "onTableChange"]),
      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(_component_MainFooter)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("h5", _hoisted_17, _toDisplayString(_ctx.$t("purchase_payment_report_page.advanced_filter")), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close shadow-none",
              "data-bs-dismiss": "modal",
              "aria-label": _ctx.$t('common.close')
            }, null, 8, _hoisted_18)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("purchase_payment_report_page.warehouse")), 1),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select bg-light border-0 fs-14 shadow-none",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.warehouse_id) = $event))
                }, [
                  _createElementVNode("option", _hoisted_23, _toDisplayString(_ctx.$t("purchase_payment_report_page.all_warehouses")), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warehouses, (warehouse) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: warehouse.id,
                      value: warehouse.id
                    }, _toDisplayString(warehouse.name), 9, _hoisted_24))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.filters.warehouse_id]
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("purchase_payment_report_page.supplier")), 1),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select bg-light border-0 fs-14 shadow-none",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.supplier_id) = $event))
                }, [
                  _createElementVNode("option", _hoisted_27, _toDisplayString(_ctx.$t("purchase_payment_report_page.all_suppliers")), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suppliers, (supplier) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: supplier.id,
                      value: supplier.id
                    }, _toDisplayString(supplier.name), 9, _hoisted_28))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.filters.supplier_id]
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t("purchase_payment_report_page.payment_method")), 1),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select bg-light border-0 fs-14 shadow-none",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.method_id) = $event))
                }, [
                  _createElementVNode("option", _hoisted_31, _toDisplayString(_ctx.$t("purchase_payment_report_page.all_payment_methods")), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentMethods, (method) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: method.id,
                      value: method.id
                    }, _toDisplayString(method.name), 9, _hoisted_32))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.filters.method_id]
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.$t("purchase_payment_report_page.from_date")), 1),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.from_date) = $event)),
                  type: "date",
                  class: "form-control bg-light border-0 fs-14 shadow-none"
                }, null, 512), [
                  [_vModelText, _ctx.filters.from_date]
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t("purchase_payment_report_page.to_date")), 1),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters.to_date) = $event)),
                  type: "date",
                  class: "form-control bg-light border-0 fs-14 shadow-none"
                }, null, 512), [
                  [_vModelText, _ctx.filters.to_date]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-light",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
            }, _toDisplayString(_ctx.$t("purchase_payment_report_page.reset")), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
            }, _toDisplayString(_ctx.$t("purchase_payment_report_page.apply_filter")), 1)
          ])
        ])
      ])
    ])
  ], 64))
}